<template>
      <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
      <div class="vh-100 is-vcentered is-mobile">
      <div class="column is-12-tablet is-offset-0-tablet is-10-fullhd is-offset-1-fullhd">
        <div class="columns is-justify-content-center">
            <div class="column is-6-tablet is-4-desktop">
                <ul class="steps">
                    <li class="active"><span><img src="img/check.svg" ></span></li>
                    <li class="active"><span><img src="img/check.svg" ></span></li>
                    <li class="active"><span>3</span></li>
                </ul>
            </div>
        </div>
        <!--<h1 class="is-size-4 has-text-weight-bold m-b-40">Create an account</h1>-->
        <div class="columns is-desktop is-flex-wrap-wrap">
          <div class="column is-6-desktop p-r-25-desktop">
            <div class="columns is-vcentered is-mobile is-flex-wrap-wrap">
              <div class="column is-4 is-6-desktop is-6-fullhd">
                <p>Gender</p>
              </div>
              <div class="column is-8 is-6-desktop is-6-fullhd col-field-wrapper">
                      <b-field class="field-radio"
                      >
                  <b-radio-button v-model="form.gender"
                                  native-value="F" >
                    <span>Female</span>
                  </b-radio-button>
                  <b-radio-button v-model="form.gender"
                                  native-value="M">
                    <span>Male</span>
                  </b-radio-button>
                  <b-radio-button v-model="form.gender"
                                  native-value="O">
                    Other
                  </b-radio-button>
                </b-field>
              </div>
            </div>
            <!-- /Genre -->
            <div class="columns is-vcentered is-mobile">
              <div class="column is-6 is-6-desktop is-6-fullhd is-flex-wrap-wrap">
                <p>Marital status</p>
              </div>
              <div class="column is-6 is-6-desktop is-6-fullhd col-field-wrapper">
                <b-field class="field-radio">
                  <b-radio-button v-model="form.maritalstatus"
                                  native-value="M" >
                    <span>Married</span>
                  </b-radio-button>
                  <b-radio-button v-model="form.maritalstatus"
                                  native-value="S">
                    <span>Single</span>
                  </b-radio-button>
                </b-field>
              </div>
            </div>
            <!-- /Marital status -->
            <div class="columns is-vcentered is-mobile is-flex-wrap-wrap">
              <div class="column is-12">
                <p class="m-b-40">Do you hold, or ever had, any of the following?</p>
                <div class="columns is-mobile" >
                  <div class="column is-8 p-l-40-mobile p-l-50-tablet">
                    <p>Stocks & Shares ISA</p>
                  </div>
                  <div class="column is-4 col-field-wrapper">
                    <b-field class="field-radio">
                      <b-radio-button v-model="form.stockssharesisa"
                                      :native-value="true" >
                          <span>Yes</span>
                      </b-radio-button>
                      <b-radio-button v-model="form.stockssharesisa"
                                      :native-value="false">
                          <span>No</span>
                      </b-radio-button>
                    </b-field>
                  </div>
                </div>
                <div class="columns is-mobile is-flex-wrap-wrap" >
                  <div class="column is-8 p-l-40-mobile p-l-50-tablet">
                    <p>Self Invested Pension Plan (SIPP)</p>
                  </div>
                  <div class="column is-4 col-field-wrapper">
                    <b-field class="field-radio">
                      <b-radio-button v-model="form.selfinverstedpensionplan"
                                      :native-value="true" >
                          <span>Yes</span>
                      </b-radio-button>
                      <b-radio-button v-model="form.selfinverstedpensionplan"
                                      :native-value="false">
                          <span>No</span>
                      </b-radio-button>
                    </b-field>

                  </div>
                </div>
                <!--
                <div class="columns is-mobile" >
                  <div class="column is-8 p-l-40-mobile p-l-50-tablet">
                    <p>a Regular Brokerage Account?</p>
                  </div>
                  <div class="column is-4 col-field-wrapper">
                    <b-field>
                        <b-switch

                            v-model="form.regularbrokerageaccount"
                        >
                        </b-switch>
                    </b-field>
                  </div>
                </div> -->
                <div class="columns is-mobile is-flex-wrap-wrap" >
                  <div class="column is-8 p-l-40-mobile p-l-50-tablet">
                    <p>Offshore Bond</p>
                  </div>
                  <div class="column is-4 col-field-wrapper">
                    <b-field class="field-radio">
                      <b-radio-button v-model="form.offshorebond"
                                      :native-value="true" >
                          <span>Yes</span>
                      </b-radio-button>
                      <b-radio-button v-model="form.offshorebond"
                                      :native-value="false">
                          <span>No</span>
                      </b-radio-button>
                    </b-field>

                  </div>
                </div>
                <div class="columns is-mobile is-flex-wrap-wrap" >
                  <div class="column is-8 p-l-40-mobile p-l-50-tablet">
                    <p>Venture Capital Trust (VCT)</p>
                  </div>
                  <div class="column is-4 is-3-desktop is-2-fullhd col-field-wrapper">

                    <b-field class="field-radio">
                      <b-radio-button v-model="form.investedinvcts"
                                      :native-value="true" >
                          <span>Yes</span>
                      </b-radio-button>
                      <b-radio-button v-model="form.investedinvcts"
                                      :native-value="false">
                          <span>No</span>
                      </b-radio-button>
                    </b-field>

                  </div>
                </div>

              </div>
            </div>
            <!-- /Do you have... -->
          </div>
          <!-- /col-left -->

          <div class="column is-6-desktop p-l-25-desktop">
            <div class="columns is-vcentered is-tablet is-flex-wrap-wrap">
              <div class="column is-6 is-12-desktop is-5-fullhd p-b-0-mobile">
                <p>Investable capital</p>
              </div>
              <div class="column is-6 is-12-desktop is-7-fullhd col-field-wrapper p-t-10-mobile">
                      <b-field class="field-radio"
                      >

                  <b-radio-button v-model="form.investablecapital"
                                  native-value="<10000" >
                    <span>&#60; 10,000</span>
                  </b-radio-button>
                  <b-radio-button v-model="form.investablecapital"
                                  native-value="10000-50000">
                    <span>10,000 to 50,000</span>
                  </b-radio-button>
                  <b-radio-button v-model="form.investablecapital"
                                  native-value=">50000">
                    <span>> 50,000</span>
                  </b-radio-button>
                </b-field>
              </div>
            </div>
            <!-- /Investable capital cccc-->
             <div class="columns is-vcentered is-tablet is-flex-wrap-wrap">
              <div class="column is-6 is-12-desktop is-6-fullhd p-b-0-mobile">
                <p>Typical investment time horizon</p>
              </div>
              <div class="column is-6 is-12-desktop is-6-fullhd col-field-wrapper p-t-10-mobile">
                <b-field class="field-radio">
                  <b-radio-button v-model="form.investmenttimehorizon"
                                  native-value="<1Y" >
                    <span>&#60; 1 Year</span>
                  </b-radio-button>
                  <b-radio-button v-model="form.investmenttimehorizon"
                                  native-value="1-3Y">
                    <span>1 - 3 Years</span>
                  </b-radio-button>
                  <b-radio-button v-model="form.investmenttimehorizon"
                                  native-value=">3Y">
                    <span>> 3 Years</span>
                  </b-radio-button>
                </b-field>
              </div>
            </div>
          </div>
          <!-- /col-right -->
        </div>
        <div class="columns is-vcentered is-desktop is-flex-wrap-wrap">
          <div class="column is-6 is-offset-3">
            <div class="is-flex buttons-wrapper">
              <span
                  @click="save" class="button is-secundary m-b-15-mobile btn-clear" style="height: 45px;">Come back later</span>
              <span @click="saveAndMove" class="button is-primary">Finish</span>
            </div>
          </div>
        </div>

      </div>
    </div>
      </ValidationObserver>

</template>

<style scoped>

</style>

<script>

import {ValidationObserver, setInteractionMode} from 'vee-validate';


setInteractionMode('eager')

export default {
  name: 'SignUp3',
    props: {
        profile: Object,
        prevRoute:String,
    },
    components: {
        ValidationObserver
    },
    data() {
        return {
            form: {}
        }
    },
    methods: {
        saveAndMove(){
            this.$refs.observer.validate().then(async success => {
                if (!success) {
                    const el = document.querySelector(".help.is-danger:first-of-type");
                    el.scrollIntoView(true);
                    window.scrollBy(0, -150);
                    return;
                }
                this.form.completedstage2 = true
                this.$emit("update", this.form)
                this.$store.commit("auth/SET_PROFILE",2)
                this.$toast.success("You successfully completed your registration")
                this.$router.push(this.prevRoute)
                if(this.$store.state.auth.userProfile.is_new_user) this.$router.push("/")
                else this.$router.go(-1);
            })
        },
        save() {
            this.$refs.observer.validate().then(async success => {
                if (!success) {
                    const el = document.querySelector(".help.is-danger:first-of-type");
                    el.scrollIntoView(true);
                    window.scrollBy(0, -150);
                    return;
                }
                this.$emit("update", this.form)
                this.$toast.success("You profile has been saved")
                if(this.$store.state.auth.userProfile.is_new_user) this.$router.push("/")
                else this.$router.go(-1);
            })
        }
    },
    watch:{
        profile:{
            immediate: true,
            handler: function(newProfile) {
                this.form = newProfile
            }
        }
    }
}
</script>


